module.exports = __webpack_public_path__ + "media/components/page-header/static/mountain-badge--light-c8aca2bacad72ef1974b4ca978572847.svg";